export const INIT_POST = 'INIT_POST';
export const INIT_MY_POST = 'INIT_MY_POST';
export const SET_SELECTED_POST = 'SET_SELECTED_POST';
export const CREATE_POST = 'CREATED_POST';
export const DELETE_POST = 'DELETE_POST';
export const UPDATE_POST = 'UPDATE_POST';
export const CREATE_COMMENT = 'CREATE_COMMENT';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const CHANGE_USERNAME = 'CHANGE_USERNAME';
export const CREATE_LIKE = 'CREATE_LIKE';
export const DELETE_LIKE = 'DELETE_LIKE';
